import React, { useState } from "react";
import Contact from "../Contact/Contact";
import Footer from "../Footer/Footer";
import Landing from "../Landing/Landing";
import Navbar from "../NavBar/Navbar";
import NavbarMenu from "../NavbarMenu/NavbarMenu";
import SideBar from "../SideBar/SideBar";
import "./Content.css";
import "./Achivement.css";
import award_1 from "../../image/award_1.jpg";
import award_2 from "../../image/award_2.jpg";
import award_3 from "../../image/award_3.jpg";
import award_4 from "../../image/award_4.jpg";
import Slider from "react-slick";

function Achievements(props) {
  const { cover, sidebar_data, side_heading, side_sub_heading } = props;
  const [isScrolled, setIsScrolled] = useState(false);
  const [isShow, steIsShow] = useState(false);
  const handleScroll = (e) => {
    console.log("asd");
    if (e.target.scrollTop > 0 && !isScrolled) {
      setIsScrolled(true);
    }
    if (e.target.scrollTop === 0) {
      setIsScrolled(false);
    }
  };
  const handleClick = () => {
    steIsShow(!isShow);
    console.log(isShow);
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    autoplay: true,
    autoplaySpeed: 2500,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  const images = [
    award_1,
    award_2,
    award_3,
    award_4,
  ];

  return (
    <div className="content_main" onScroll={handleScroll}>
      <Navbar isScrolled={isScrolled} handleClick={handleClick} />
      <NavbarMenu isShow={isShow} handleClick={handleClick} />
      <Landing video={false} cover={cover} />
      <div className="contentmain_cont">
        <div style={{ width: "min-content" }}>
          <SideBar
            sidebar_data={sidebar_data}
            side_heading={side_heading}
            side_sub_heading={side_sub_heading}
          />
          <Contact />
        </div>
        <div>
          <div className={`f-2 f-500 mb-3`}>
            Achievements & Laurels
          </div>
          <div >
            <div className="d-flex gap-2 mt-1">
              <div className="container">
                <div className="achievement-copy color-grey f-500">
                  <p className="achievement-quote">
                    "The harder you work for something, the greater you'll feel
                    when you achieve it."
                  </p>
                  <p>
                    It is a jubilant and ecstatic moment for HGS to announce
                    that our school has been awarded as an Edvantage Global
                    School and recognized as a change maker in the field of
                    education.
                  </p>

                  <section className="achievement-section">
                    <h3>Results Class XII, CBSE Boards</h3>
                    <p>
                      <strong>HGS Varanasi</strong> secured 100% results in
                      Class XII. Akriti Tiwari topped the school with 97%
                      amongst all four streams.
                    </p>

                    <h4>Science Stream</h4>
                    <p>
                      Shalu Kumari topped the Science Stream, Sameeksha Sharma
                      secured the second position, and Vaishnavi Yadav secured
                      the third position.
                    </p>

                    <h4>Commerce Stream</h4>
                    <p>
                      Akriti Tiwari topped the Commerce Stream with 97%, Shriya
                      Baranwal secured the second position with 90.2%, and
                      Akriti Tiwari-2 secured the third position with 89.4%.
                    </p>

                    <h4>Humanities Stream</h4>
                    <p>
                      Sandhya Yadav secured the first position with 93.8%,
                      Trisha Yadav secured the second position with 89.2%, and
                      Kajal Rai secured the third position with 84.4%.
                    </p>

                    <p className="achievement-highlight">
                      Shalu Kumari scored 100% marks in Web Application.
                    </p>
                  </section>

                  <section className="achievement-section">
                    <h3>Results Class X, CBSE Boards</h3>
                    <p>
                      <strong>HGS Varanasi</strong> secured 100% results in
                      Class X. Kartikeya Yadav topped the school with 98.2%,
                      Ansh Jaiswal secured the second position with 98%, and
                      Aparna Singh secured the third position with 96.6%.
                    </p>

                    <p>
                      Kartikeya Yadav scored 100% marks in IT and Science.
                      Sameer Kumar scored 100% marks in IT, and Ansh Jaiswal
                      scored 100% marks in Science.
                    </p>

                    <p className="achievement-note">
                      All the toppers were honoured by the school's Principal,
                      Dr. Ambika Prasad Gaur.
                    </p>
                  </section>
                </div>


                <div className="container py-4 silderac">
                  <h2 className="fw-bold text-center mb-4">Awards Gallery</h2>

                  <Slider {...settings}>
                    {images.map((img, i) => (
                      <div key={i} className="img-slide-wrapper">
                        <img src={img} alt="gallery" className="slider-img" />
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
export default Achievements;
